var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"to-top d-flex align-center justify-center cursor-pointer",on:{"click":_vm.goTo}},[_c('v-icon',{attrs:{"color":"white","size":_vm.isMd ? '20px': '30px'}},[_vm._v("mdi-chevron-up")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }